import React from "react";
import BondPlayInfoModal from "./BondPlayInfoModal";
import { formatCasinoCoin, MIN_CASINO_BET } from "../../utils/casinoHelpers";

const BondSpinInfoModal = ({ open = false, onClose }) => (
  <BondPlayInfoModal
    open={open}
    onClose={onClose}
    titleId="bplay-spin-info-title"
    title="Bond Spin"
    subtitle="Host a roulette table or bet on another player's wheel before time runs out."
    sections={[
      {
        title: "Create or join",
        items: [
          <>Create a table with a COIN pool and a deadline, or pick a live table from the rail.</>,
          <>The host funds the table; players bet against that pool using COIN.</>,
        ],
      },
      {
        title: "Reverse ticket",
        items: [
          <>Tap <strong>Reverse ticket</strong>, choose an outcome (color, odd/even, range, exact number, etc.), and stake at least {formatCasinoCoin(MIN_CASINO_BET)} COIN.</>,
          <>Each outcome shows its multiplier and potential win based on the table pool.</>,
          <>You can only have one pending ticket at a time. Play, cancel, or let it expire before reversing another.</>,
          <>After reversing a ticket, you have 90 seconds to tap <strong>Play</strong> or your stake is refunded automatically.</>,
        ],
      },
      {
        title: "Play & settle",
        items: [
          <>When your bet is ready, tap <strong>Play</strong> to spin the wheel for that table.</>,
          <>If your outcome hits, you win from the host's allocated pool.</>,
          <>The table closes automatically when the host's deadline is reached.</>,
        ],
      },
      {
        title: "Timing",
        items: [
          <>Each table has a countdown deadline shown under the wheel.</>,
          <>Reverse tickets and play before the table closes.</>,
          <>When the deadline passes, the table closes and any unplayed bets are refunded.</>,
        ],
      },
    ]}
  />
);

export default BondSpinInfoModal;
